module.exports = __webpack_public_path__ + "img/ic_home_city_center_white.e6f44a49.svg";